// The curated font list for form branding — Google Fonts families the
// renderer knows how to load. Curated on purpose: a free-text family name
// would put arbitrary strings into a <link> URL and unvetted fonts into the
// respondent's page. '' (System default) loads nothing.
export interface BrandFont {
  /** the family name, exactly as Google Fonts knows it ('' = system stack) */
  family: string;
  /** what the pickers show */
  label: string;
}

export const BRAND_FONTS: BrandFont[] = [
  { family: '', label: 'System default' },
  { family: 'Inter', label: 'Inter — clean neutral' },
  { family: 'Roboto', label: 'Roboto' },
  { family: 'Open Sans', label: 'Open Sans' },
  { family: 'Lato', label: 'Lato' },
  { family: 'Montserrat', label: 'Montserrat — geometric' },
  { family: 'Poppins', label: 'Poppins — rounded' },
  { family: 'Nunito', label: 'Nunito — soft' },
  { family: 'Work Sans', label: 'Work Sans' },
  { family: 'IBM Plex Sans', label: 'IBM Plex Sans' },
  { family: 'Merriweather', label: 'Merriweather — serif' },
  { family: 'Playfair Display', label: 'Playfair Display — display serif' },
  { family: 'Source Serif 4', label: 'Source Serif — serif' },
];

const KNOWN = new Set(BRAND_FONTS.map((f) => f.family).filter(Boolean));

/** Only curated families ever reach the <link> URL or a CSS variable. */
export const knownFont = (family?: string): string | null =>
  family && KNOWN.has(family) ? family : null;

/** The Google Fonts stylesheet URL for the theme's families, or null. */
export function fontsHref(font?: { body?: string; heading?: string }): string | null {
  const families = [...new Set([knownFont(font?.body), knownFont(font?.heading)].filter(Boolean))] as string[];
  if (!families.length) return null;
  const parts = families.map((f) => `family=${encodeURIComponent(f).replace(/%20/g, '+')}:wght@400;600;700`);
  return `https://fonts.googleapis.com/css2?${parts.join('&')}&display=swap`;
}

/** A CSS font-family value with real fallbacks, or null for the system stack. */
export const fontStack = (family?: string): string | null =>
  knownFont(family) ? `'${family}', system-ui, -apple-system, 'Segoe UI', sans-serif` : null;
